<template>
  <div class="row mt-2">
    <div class="col-6">
      <vs-input readonly class="w-100" label="Entidad" v-model="entity"/>
    </div>
    <div class="col-6">
      <vs-input readonly class="w-100" label="Materia" v-model="theme"/>
    </div>
    <div class="col-12 mt-2">
      <label>Descripci&oacute;n</label>
      <b-form-textarea
        class="w-100"
        v-model="description"
        rows="1"
        readonly
        no-resize
      />
    </div>
    <div class="col-6 mt-2">
      <label>Firmado por:</label>
      <div>
        <p v-if="!signers.length">
          No tiene firmantes
        </p>
        <b-media
          no-body
          v-for="(user, index) in signers"
          :key="index"
          class="mb-2"
        >
          <b-media-aside class="mr-75">
            <b-avatar
              rounded
              size="36"
            />
          </b-media-aside>
          <b-media-body class="my-auto">
            <h6 class="mb-0">
              {{ user.name }}
            </h6>
            <small>{{ user.entityName }}</small>
          </b-media-body>
        </b-media>
      </div>
    </div>
    <div class="col-6 mt-2">
      <div>
        <label>Visadores:</label>
        <p v-if="!certifiers.length">
          No tiene visadores
        </p>
        <b-media
          no-body
          v-for="(user, index) in certifiers"
          :key="index"
          class="mb-2"
        >
          <b-media-aside class="mr-75">
            <b-avatar
              rounded
              size="36"
            />
          </b-media-aside>
          <b-media-body class="my-auto">
            <h6 class="mb-0">
              {{ user.name }}
            </h6>
            <small>{{ user.entityName }}</small>
          </b-media-body>
        </b-media>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocDigitalInputs',
  props: ['entity', 'theme', 'description', 'certifiers', 'signers']
};
</script>
